<div id="toolbar-container" class="toolbar-container no-select">
  <!-- Part for tooltip on no occurrence -->
  <ng-template #noOccurrenceTooltipStem>
    <span>{{ 'document.no-occurrence-for-stem' | translate }}</span>
  </ng-template>
  <ng-template #noOccurrenceTooltipInput>
    <span>{{ 'document.no-occurrence-for-input' | translate }}</span>
  </ng-template>

  <div class="toolbar-body">
    @if (displayToolbar) {
      <div class="keywords-section">
        <div class="stem-container d-flex">
          @if (hasExcerpt) {
            <ex-button class="excerpt-button" size="small" type="ai" variant="tonal" (click)="excerptSelect.emit()">
              <mat-icon svgIcon="sparks-filled" />
              {{ 'document.keyword-search-header-excerpt' | translate }}
            </ex-button>
          }
          @for (match of matchTermMatrix; track trackByStem($index, match)) {
            <div
              [ngClass]="{
                selected: $safeNavigationMigration(selectedTerms?.includes(match.stem)),
                unselected: !selectedTerms?.includes(match.stem),
                'keyword-type-input': match.type === SearchKeywordTypeEnum.USER_INPUT,
                'no-occurrence': match.occurrencePages?.length === 0,
              }"
              class="stem-button"
              data-cy="stem-button-keyword-admin-doc-view"
              (click)="onClickTerm(match)"
              (mouseenter)="hoveredKeyword = match"
              (mouseleave)="hoveredKeyword = null"
              [ngbTooltip]="
                match.occurrencePages && match.occurrencePages.length === 0
                  ? match.type === SearchKeywordTypeEnum.USER_INPUT
                    ? noOccurrenceTooltipInput
                    : noOccurrenceTooltipStem
                  : ''
              "
              tooltipClass="default-tooltip-class {{
                match.type === SearchKeywordTypeEnum.USER_INPUT ? 'tooltip-max-190' : 'tooltip-max-300'
              }}"
              placement="bottom"
              container="body"
              [openDelay]="500"
            >
              <div class="d-table">
                <!-- edit icons for user inputs -->
                <!-- edit input unselected -->
                @if (match.type === SearchKeywordTypeEnum.USER_INPUT && !selectedTerms?.includes(match.stem)) {
                  <span [ngClass]="{ 'filter-no-occurrence-icon': match.occurrencePages?.length === 0 }" class="d-table-cell align-middle">
                  </span>
                }
                <!-- edit input selected -->
                @if (match.type === SearchKeywordTypeEnum.USER_INPUT && selectedTerms?.includes(match.stem)) {
                  <span class="d-table-cell align-middle"> </span>
                }
                <!-- keyword value displayed (stem or input) -->
                <span
                  [ngClass]="{
                    'text-line-through': match.occurrencePages?.length === 0 && match.type === SearchKeywordTypeEnum.USER_INPUT,
                  }"
                  class="d-table-cell stem-text align-middle"
                >
                  <span>{{ match.stem | articleTitleCase }}</span>
                </span>
                <!-- occurrence counters & loader -->
                @if (match.occurrencePages !== null && !(match.type === SearchKeywordTypeEnum.USER_INPUT && hoveredKeyword === match)) {
                  <span class="d-table-cell stem-count align-middle">
                    <span>{{ match.occurrencePages?.length }}</span>
                  </span>
                }
                @if (match.occurrencePages === null && !timeoutElapsed && match.type !== SearchKeywordTypeEnum.USER_INPUT) {
                  <span class="d-table-cell stem-count align-middle">
                    <div class="stem-count-loader"></div>
                  </span>
                }
                @if (match.occurrencePages === null && timeoutElapsed && match.type !== SearchKeywordTypeEnum.USER_INPUT) {
                  <span class="d-table-cell stem-count align-middle">
                    <div>?</div>
                  </span>
                }
                @if (match.occurrencePages === null && match.type === SearchKeywordTypeEnum.USER_INPUT) {
                  <span class="d-table-cell stem-count align-middle">
                    <div class="stem-count-loader"></div>
                  </span>
                }
                <!-- icons to delete user input when selected and unselected -->
                <!-- delete input selected -->
                @if (
                  match.type === SearchKeywordTypeEnum.USER_INPUT &&
                  hoveredKeyword === match &&
                  selectedTerms?.includes(match.stem) &&
                  match.occurrencePages !== null
                ) {
                  <span class="d-table-cell align-middle">
                    <img
                      src="../../../assets/images/27-icon-close-circle-500.svg"
                      alt="delete-user-input-icon"
                      [style.cursor]="'pointer'"
                      class="icon-16 d-table-cell align-item-center delete-input-icon color-primary-500"
                      (click)="onDeleteUserInput(match)"
                      (mouseover)="$any($event.target).src = '../../../assets/images/27-icon-close-circle-fill-500.svg'"
                      (mouseout)="$any($event.target).src = '../../../assets/images/27-icon-close-circle-500.svg'"
                    />
                  </span>
                }
                <!-- delete input unselected -->
                @if (
                  match.type === SearchKeywordTypeEnum.USER_INPUT &&
                  hoveredKeyword === match &&
                  !selectedTerms?.includes(match.stem) &&
                  match.occurrencePages
                ) {
                  <span
                    [ngClass]="{ 'filter-no-occurrence-icon': match.occurrencePages && match.occurrencePages.length === 0 }"
                    class="d-table-cell align-middle"
                  >
                    <img
                      src="../../../assets/images/27-icon-close-circle-800.svg"
                      alt="delete-user-input-icon"
                      [style.cursor]="'pointer'"
                      class="icon-16 d-table-cell align-item-center delete-input-icon"
                      (click)="onDeleteUserInput(match)"
                      (mouseover)="$any($event.target).src = '../../../assets/images/27-icon-close-circle-fill-800.svg'"
                      (mouseout)="$any($event.target).src = '../../../assets/images/27-icon-close-circle-800.svg'"
                    />
                  </span>
                }
              </div>
            </div>
          }
          <!-- user input (ctrl-F) -->
          <span class="stem-button input-text-container d-flex">
            <div class="d-table">
              <mat-icon svgIcon="edit-800" class="icon-12 me-1 d-table-cell align-middle input-edit-icon"></mat-icon>
            </div>
            <div class="d-table">
              <input
                #searchTermInput
                (keyup.enter)="addUserInput(searchTermInput.value)"
                [(ngModel)]="userInput"
                [style.padding-right]="userInput.length < 2 ? '6px' : '0'"
                appOutlineNone
                autoSizeInput
                autocomplete="off"
                class="input-text d-table-cell align-middle"
                id="searchTermInput"
                placeholder="{{ 'document.first-input' | translate }}"
                type="text"
              />
            </div>
            <div class="d-table h-100">
              @if (userInput.length >= 2) {
                <img
                  src="/assets/images/27-icon-checkmark-validate.svg"
                  alt="input-validation-icon"
                  class="icon-17 me-1 d-table-cell align-item-center cursor-pointer input-validation-icon"
                  (mouseover)="$any($event.target).src = '/assets/images/27-icon-checkmark-validate-fill.svg'"
                  (mouseout)="$any($event.target).src = '/assets/images/27-icon-checkmark-validate.svg'"
                  (click)="addUserInput(userInput)"
                />
              }
            </div>
          </span>
          @if (!stems && matchTermMatrix.length === 0) {
            <div class="no-match-stems d-table">
              <div class="d-table-cell align-middle fst-italic">
                {{ 'document.unavailable-suggestions' | translate }}
              </div>
            </div>
          }
        </div>
      </div>
    }

    <div class="search-pagination-section">
      <div class="pagination-part d-flex">
        <div class="page-counter d-table">
          <div class="page-counter-container d-table-cell align-middle">
            @if (occurrencePagesCounter) {
              <div class="d-flex">
                <span class="page-counter">{{ occurrencePagesCounter }}</span>
                @if (occurrencePagesCounter === 1) {
                  <span class="page-text"> {{ 'document.keyword-search-header-one-occ-page' | translate | uppercase }}</span>
                }
                @if (occurrencePagesCounter > 1) {
                  <span class="page-text"> {{ 'document.keyword-search-header-multi-occ-page' | translate | uppercase }}</span>
                }
              </div>
            }
          </div>
        </div>

        <div class="search-pagination">
          <ng-content class="search-pagination" select="[searchPagination]"></ng-content>
        </div>
      </div>

      <!-- Part for PDF menus -->
      <ng-content class="pdf-menus" select="[pdfMenus]"></ng-content>
    </div>
  </div>
</div>
